import { useEffect, useRef } from 'react';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import {
   registerSuperProperties,
   setPeopleProperties,
   unregisterSuperProperty,
} from 'src/analytics/mixpanel';

const toMixpanelKey = (ldKey: string): string =>
   `ld_${ldKey.replace(/-/g, '_')}`;

export const useLDFlagSync = (): void => {
   const flags = useFlags();
   const ldClient = useLDClient();
   const prevKeysRef = useRef<Set<string>>(new Set());

   useEffect(() => {
      if (!ldClient) return;

      const allFlags = ldClient.allFlags();
      const transformed: Record<string, unknown> = {};
      const currentKeys = new Set<string>();

      for (const [key, value] of Object.entries(allFlags)) {
         if (key.startsWith('$')) continue;
         const mpKey = toMixpanelKey(key);
         transformed[mpKey] = value;
         currentKeys.add(mpKey);
      }

      registerSuperProperties(transformed);
      setPeopleProperties(transformed);

      Array.from(prevKeysRef.current).forEach((oldKey) => {
         if (!currentKeys.has(oldKey)) {
            unregisterSuperProperty(oldKey);
         }
      });

      prevKeysRef.current = currentKeys;
   }, [flags, ldClient]);
};
